import React, { Component } from "react";
import { HashRouter as Router } from "react-router-dom";
import { Switch, Route } from "react-router-dom";

import moment from "moment";
import "moment/locale/es";

import Mancheta from "./components/Mancheta";
import Footer from "./components/Footer";
import Inicio from "./components/Inicio";
import Weather from "./components/Weather";
import NotFound from "./components/NotFound";

import "./css/normalize.css";
import "./App.css";
import "./css/weather-icons.min.css";

moment.locale("es");

class App extends Component {
	constructor() {
		super();
		this.state = {
			doom: null
		};
	}

	render() {
		return (
			<div className="App">
				<Mancheta />
				<Router>
					<Switch>
						<Route exact path="/" component={Inicio} />
						<Route path="/itinerario/:procesion" component={Inicio} />
						<Route exact path="/tiempo" component={Weather} />
						<Route component={NotFound} />
					</Switch>
				</Router>
				<Footer />
			</div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js